import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import useDataStore from '../Data/dataStore';
import { API, tabletWidth } from '../globalUtils';
import GradientWrapper from '../GradientBox/GradientWrapper';
import { LogoGraphics } from '../Header/LogoGraphics';
import { LogoTextGraphics } from '../Header/LogoTextGraphics';
import { MenuCloseGraphics } from '../Header/MenuCloseGraphics';
import MenuList from './MenuList';
import useMenuStore from './menuStore';
import { sanitize } from '../../utils';
import { useNavigate } from 'react-router-dom';
const Menu = () => {
    const navigate = useNavigate();
    const { open } = useMenuStore();
    const setup = useDataStore((state) => state.data[API.setup]);
    const containerRef = useRef(null);
    useEffect(() => {
        return () => {
            if (containerRef.current) {
                containerRef.current.removeEventListener('wheel', handleWheel);
            }
        };
    }, []);
    const handleWheel = (event) => {
        event.preventDefault();
    };
    const onContainerRef = (ref) => {
        if (ref && !containerRef.current) {
            containerRef.current = ref;
            containerRef.current.addEventListener('wheel', handleWheel, {
                passive: false,
            });
        }
    };
    if (!setup) {
        return null;
    }
    const { menu, main_menu_legal, main_menu_legal_mobile, main_menu_text } = setup;
    const closeMenu = () => {
        useMenuStore.getState().setOpen(false);
    };
    const gotoHome = () => {
        navigate('/');
    };
    const onMouseUp = (evt) => {
        if (evt.target.parentElement?.classList.contains('menu-container')) {
            closeMenu();
        }
    };
    return (_jsxs("div", { className: `menu-container${open ? ' open' : ''}`, ref: onContainerRef, onMouseUp: onMouseUp, children: [_jsx(GradientWrapper, { active: true }), _jsx("div", { className: "menu-slider", children: _jsxs("div", { className: "menu-wrapper", children: [_jsx("div", { className: "header-left", children: _jsxs("div", { className: `logo mobile-logo`, onClick: gotoHome, children: [_jsx(LogoGraphics, {}), _jsx(LogoTextGraphics, {})] }) }), _jsxs("div", { className: "menu-floating-container", children: [_jsx(GradientWrapper, { active: true }), _jsx("div", { className: "menu-floating-border" }), _jsxs("div", { className: "info-panel alt-font", children: [_jsx("div", { className: "info-panel-line" }), _jsx("div", { className: "info-panel-top", children: _jsx(LogoGraphics, {}) }), _jsxs("div", { className: "info-panel-bottom", children: [_jsx("div", { className: "info-panel-logo-text", children: _jsx(LogoTextGraphics, {}) }), _jsx("div", { className: "info-panel-details", dangerouslySetInnerHTML: {
                                                        __html: sanitize(main_menu_text),
                                                    } }), _jsx("div", { className: "info-panel-legal", dangerouslySetInnerHTML: {
                                                        __html: sanitize(window.innerWidth <= tabletWidth
                                                            ? main_menu_legal_mobile
                                                            : main_menu_legal),
                                                    } })] })] }), _jsx(MenuList, { closeMenu: closeMenu, open: open })] }), _jsx("div", { className: "menu-close-button", children: _jsxs("div", { className: "header-menu-button", onClick: closeMenu, children: [_jsx("div", { className: "header-menu-background", children: _jsx(GradientWrapper, { active: true, mask: "radial-gradient(circle, rgb(0, 0, 0) 70%, rgba(0, 0, 0, 0) 70%)" }) }), _jsx(MenuCloseGraphics, {})] }) })] }) })] }));
};
export default Menu;
